import { render, staticRenderFns } from "./categorysermon_modal.vue?vue&type=template&id=37f7e6ec&"
import script from "./categorysermon_modal.vue?vue&type=script&lang=js&"
export * from "./categorysermon_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports